module.exports = __webpack_public_path__ + "ba404a705130c5251bec5041b41e0376.pdf";